import React from 'react';
import { Currency } from 'ui-toolkit/components/Currency';
import { eFilterType } from 'ui-toolkit/components/DataGrid';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

const BankAccountCell: React.FC<{ row: { accountName?: string; accountLegalName?: string; accountNumber?: string } }> = ({ row }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const displayName = isSpruceWithZillowEnabled ? row.accountLegalName : row.accountName;
  return (
    <>
      {displayName} ({row.accountNumber})
    </>
  );
};

export const BankAccountRow = {
  dataField: 'accountName',
  headerStyle: { width: '150px' },
  text: 'Bank Account',
  formatter: (value: any, row: { accountName?: string; accountLegalName?: string; accountNumber?: string }) => (
    <BankAccountCell row={row} />
  ),
};
export const AmountCents = (amountCents?: number | string) => ({
  dataField: 'amountCents',
  filterDefault: amountCents === 'number' ? amountCents.toString() : amountCents,
  filterElement: eFilterType.Currency,
  filterPlaceholder: 'Received',
  formatter: (value: any) => typeof value === 'number' && <Currency value={value} valueIsCents={true} />,
  headerStyle: { width: '120px' },
  text: 'Received',
  sort: true,
});
